module.exports = __webpack_public_path__ + "static/assets/72005810d7b58a20712589fa026ca2c6.png";